<template>
  <div class="content content-full">
    <div class="page-inner page-inner-fill">
      <div class="page-with-aside mail-wrapper bg-white">
        <div class="page-aside bg-grey1">
          <div class="aside-header">
            <div class="title">{{ $t('messages') }}</div>
            <a class="btn btn-primary toggle-email-nav" data-toggle="collapse" href="#email-app-nav" role="button" aria-expanded="false" aria-controls="email-nav">
              <span class="btn-label">
                <i class="icon-menu"></i>
              </span>
              {{ $t('menu') }}
            </a>
          </div>
          <div class="aside-nav collapse" id="email-app-nav">
            <ul class="nav">
              <li :class="{ 'active': activeClass === 'category_all' }">
                <router-link type="button" :to="{ path: '/messages/all', query: { page: 1 } }" :disabled="loading">
                  <i class="category-message fas fa-envelope-open"></i> {{ $t('inbox') }}
                  <span class="badge badge-secondary float-right" v-if="totals.category_all > 0">{{ totals.category_all }}</span>
                </router-link>
              </li>
              <!-- <li :class="{ 'active': activeClass === 'category_unread' }">
                <router-link type="button" :to="{ path: '/messages/all', query: { unread: 1, page: 1 } }" :disabled="loading">
                  <i class="fas fa-envelope"></i>{{ $t('unread_messages') }}
                  <div class="ml-3" v-if="loading">
                    <i class="fa fa-spinner fa-spin text-muted"></i>
                  </div>
                  <span class="badge badge-secondary float-right" v-if="totals.category_all > 0">{{ totals.category_all }}</span>
                </router-link>
              </li> -->
              <li :class="{ 'active': activeClass === 'category_0' }">
                <router-link type="button" :to="{ path: '/messages/all', query: { category: 0, page: 1 } }" :disabled="loading">
                  <i class="category-message fas fa-laptop"></i> Dashboard
                  <span class="badge badge-secondary float-right" v-if="totals.category_0 > 0">{{ totals.category_0 }}</span>
                </router-link>
              </li>
              <li :class="{ 'active': activeClass === 'category_1' }">
                <router-link type="button" :to="{ path: '/messages/all', query: { category: 1, page: 1 } }" :disabled="loading">
                  <i class="category-message fas fa-music"></i> {{ $t('distribution') }}
                  <span class="badge badge-secondary float-right" v-if="totals.category_1 > 0">{{ totals.category_1 }}</span>
                </router-link>
              </li>
              <li :class="{ 'active': activeClass === 'category_2' }">
                <router-link type="button" :to="{ path: '/messages/all', query: { category: 2, page: 1 } }" :disabled="loading">
                  <i class="category-message fas fa-donate"></i> {{ $t('bank') }}
                  <span class="badge badge-secondary float-right" v-if="totals.category_2 > 0">{{ totals.category_2 }}</span>
                </router-link>
              </li>
              <li :class="{ 'active': activeClass === 'category_3' }">
                <router-link type="button" :to="{ path: '/messages/all', query: { category: 3, page: 1 } }" :disabled="loading">
                  <i class="category-message fas fa-file-invoice-dollar"></i> {{ $t('subscription') }}
                  <span class="badge badge-secondary float-right" v-if="totals.category_3 > 0">{{ totals.category_3 }}</span>
                </router-link>
              </li>
              <li :class="{ 'active': activeClass === 'category_4' }">
                <router-link type="button" :to="{ path: '/messages/all', query: { category: 4, page: 1 } }" :disabled="loading">
                  <i class="category-message fas fa-calendar-times"></i> {{ $t('claims') }}
                  <span class="badge badge-secondary float-right" v-if="totals.category_4 > 0">{{ totals.category_4 }}</span>
                </router-link>
              </li>
              <li :class="{ 'active': activeClass === 'category_general' }">
                <router-link type="button" :to="{ path: '/messages/all', query: { general: 1, page: 1 } }" :disabled="loading">
                  <i class="category-message fas fa-info-circle"></i> {{ $t('announcements') }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <MessagesList v-if="$route.meta.mode === 'list'"></MessagesList>
        <MessagesDetail v-if="$route.meta.mode === 'detail'"></MessagesDetail>
      </div>
    </div>
  </div>
</template>
<script>
import MessagesList from './MessagesList'
import MessagesDetail from './MessagesDetail'
import _ from 'underscore'
import Message from '../services/messages'
export default {
  name: 'Messages',
  data: function () {
    return {
      totals: {
        categories_all: 0,
        categories_0: 0,
        categories_1: 0,
        categories_2: 0,
        categories_3: 0,
        categories_4: 0
      },
      activeClass: '',
      loading: false
    }
  },
  methods: {
    getTotals: function () {
      Message.getTotals().then(response => {
        this.totals = response.data
      })
      if (_.contains([0, 1, 2, 3, 4], parseInt(this.$route.query.category))) {
        this.activeClass = 'category_' + this.$route.query.category
      } else if (this.$route.query.unread) {
        this.activeClass = 'category_unread'
      } else if (this.$route.query.general) {
        this.activeClass = 'category_general'
      } else {
        this.activeClass = 'category_all'
      }
    }
  },
  created: function () {
    this.getTotals()
    this.$eventBus.$on('getTotalsUnreadMessages', () => {
      this.getTotals()
    })
    this.$eventBus.$on('loadingMessages', () => {
      this.loading = true
    })
    this.$eventBus.$on('loadedMessages', () => {
      this.loading = false
    })
  },
  watch: {
    '$route': function (from, to) {
      this.getTotals()
    }
  },
  components: {
    MessagesList,
    MessagesDetail
  }
}
</script>
<style lang="scss" scoped>
  .page-with-aside {
    .page-aside{
      min-height: 86.9vh;
    }
  }
  .category-message {
    min-width: 27px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Messages.vue